export interface PhotoGalleryItem {
  alt: string;
  url: string;
}

export function openPhotoGallery(photos: PhotoGalleryItem[], initialIndex: number) {
  if (!photos.length) return;

  import('photoswipe').then(async ({ default: PhotoSwipe }) => {
    await import('photoswipe/style.css');
    const lightbox = new PhotoSwipe({
      dataSource: photos.map((photo) => ({ src: photo.url, alt: photo.alt })),
      index: initialIndex,
      bgOpacity: 0.92,
      showAnimationDuration: 0,
      hideAnimationDuration: 0,
      wheelToZoom: true,
      closeOnVerticalDrag: true,
      padding: { top: 40, bottom: 40, left: 30, right: 30 },
      imageClickAction: 'zoom',
      returnFocus: true,
    });

    lightbox.on('gettingData', (event) => {
      const data = event.data;
      if (data.width && data.height) return;

      const image = new Image();
      image.src = data.src as string;
      if (image.naturalWidth && image.naturalHeight) {
        data.width = image.naturalWidth;
        data.height = image.naturalHeight;
        return;
      }

      image.onload = () => {
        data.width = image.naturalWidth;
        data.height = image.naturalHeight;
        lightbox.refreshSlideContent(event.index);
      };
      data.width = 1200;
      data.height = 900;
    });

    lightbox.init();
  });
}
